import React from 'react';
import { Navigate, Route, useParams } from 'react-router-dom';
import { AuthState, withAuth } from 'context/auth';
import { withAlerts, AlertsState } from 'context/alerts';
import { PageLoader } from 'components';

interface Props {
  auth: AuthState;
  component: React.ComponentType<any>;
  checkTerms?: boolean;
  loaderBackground?: string;
  alerts: AlertsState;
}

const ProtectedRouteWrapper = (props: Props) => {
  let { sandboxId } = useParams();

  const sandboxExists = (sandboxId: string) => {
    const currentSandbox = props.auth.sandboxesAvailable.find(
      (sandbox: any) => sandbox.id === sandboxId
    );

    return currentSandbox === undefined ? false : true;
  };

  const {
    component: Component,
    auth,
    checkTerms,
    loaderBackground,
    ...rest
  } = props;

  // while we fetch the auth-data from google
  if (auth.loggedIn === undefined) {
    return (
      <PageLoader
        hideLoader={props.alerts.message}
        loaderBackground={loaderBackground}
      />
    );
  }

  if (auth.loggedIn === false) {
    return <Navigate to={{ pathname: '/' }} />;
  }

  if (!sandboxId || !sandboxExists(sandboxId)) {
    return <Navigate to={{ pathname: '/' }} />;
  }

  if (checkTerms && auth.sandbox?.termsAccepted === false) {
    return <Navigate to={{ pathname: `/${sandboxId}` }} />;
  }

  return <Component {...rest} {...props} />;
};

export const ProtectedRoute = withAuth(withAlerts(ProtectedRouteWrapper));
